import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import { showLoader, hideLoader } from "../app/api/appApiSlice";

import useAuth from "../hooks/useAuth";

const Header = () => {
  const { username } = useAuth();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [sendLogout] = useSendLogoutMutation();

  return (
    <>
      <header className="fixed top-0 left-0 w-full bg-white shadow z-[1001]">
        <div className="container mx-auto">
          <div className="w-11/12 relative flex items-center justify-between sm:justify-between gap-4 py-4 mx-auto">
            <div className="w-32 xs:w-48">
              <Link to={"/home"}>
                <img src="/img/dashboard.png" alt="logo" />
              </Link>
            </div>
            <div className="mr-0 ml-4">
              {username && (
                <>
                  <button
                    className="max-w-fit bg-black text-white uppercase p-3 rounded-md"
                    onClick={() => {
                      dispatch(showLoader());

                      setTimeout(() => {
                        sendLogout();
                        dispatch(hideLoader());
                        navigate("/");
                      }, 3000);
                    }}
                  >
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
